// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1HbaW","colBig":"styles_colBig__35HxJ","colSmall":"styles_colSmall__3WkvY"};